import React, { useCallback } from 'react';
import { Option, Select } from 'carbon-react/lib/components/select';

import { useIntl } from '@futrli/localisation';

import { ListingPageFilterBar } from '@futrli/ui-components/components/listing-page/listing-page-filter-bar/listing-page-filter-bar';
import { ListingPageButtonToggle } from '@futrli/ui-components/components/listing-page/listing-page-button-toggle/listing-page-button-toggle';

import { SortOption } from '../../../../utils/list-filters/list-filter-utils';
import { StatusFilterValue } from './hooks/use-status-filter';

interface DashboardTemplatesFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  statusFilter: StatusFilterValue;
  onStatusChange: (value: StatusFilterValue) => void;
  sortValue: string;
  onSortChange: (value: string) => void;
  sortOptions: SortOption[];
  stickyTop?: number;
}

export const DashboardTemplatesFilters = ({
  searchTerm,
  onSearchChange,
  statusFilter,
  onStatusChange,
  sortValue,
  onSortChange,
  sortOptions,
  stickyTop
}: DashboardTemplatesFiltersProps) => {
  const intl = useIntl();

  const statusOptions = [
    { label: intl.formatMessage({ id: 'predict.all', defaultMessage: 'All' }), value: 'all' },
    { label: intl.formatMessage({ id: 'common.published', defaultMessage: 'Published' }), value: 'published' },
    { label: intl.formatMessage({ id: 'common.draft', defaultMessage: 'Draft' }), value: 'draft' }
  ];

  const handleSortChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onSortChange(event.target.value);
    },
    [onSortChange]
  );

  return (
    <ListingPageFilterBar
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      stickyTop={stickyTop}
      rightContent={
        <div style={{ minWidth: 250 }}>
          <Select
            id="dashboard-templates-sort-by"
            value={sortValue}
            onChange={handleSortChange}
            size="medium"
            label={intl.formatMessage({ id: 'predict.sort_by', defaultMessage: 'Sort by' })}
            aria-label={intl.formatMessage({ id: 'predict.sort_by', defaultMessage: 'Sort by' })}
          >
            {sortOptions.map(opt => (
              <Option key={opt.value} value={opt.value} text={opt.label} />
            ))}
          </Select>
        </div>
      }
    >
      <ListingPageButtonToggle
        label={intl.formatMessage({ id: 'common.status', defaultMessage: 'Status' })}
        options={statusOptions}
        selectedValue={statusFilter}
        onChange={value => onStatusChange(value as StatusFilterValue)}
      />
    </ListingPageFilterBar>
  );
};
